// Full-document render of the tempurpedic FinancePage: PageSkeleton (the React
// document shell) wrapping the existing finance-page body assembly. The legacy
// template had no header/footer overrides, so normal site chrome applies. The
// ``variant`` ("default" | "sale2") is resolved server-side (from APP_SLUG) and
// threaded through, selecting between the two consolidated finance-page bodies
// inside the one TempurFinancePageBody assembly.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { TempurFinancePageBody } from "../components/TempurFinancePageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton). The body template accepts Immutable
// props, to which these are assignable.
type IProps = templates.FinancePageTemplate;

export const Template = (props: IProps): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <TempurFinancePageBody
            page={props.page}
            variant={props.variant}
            apr={props.apr}
            term_months={props.term_months}
            fine_print_superscript={props.fine_print_superscript}
            headline_html={props.headline_html}
            terms_html={props.terms_html}
            hero_image_url={props.hero_image_url}
            shop_mattresses_url={props.shop_mattresses_url}
            phone_href={props.phone_href}
            phone_display={props.phone_display}
        />
    </PageSkeleton>
);
